import { render, staticRenderFns } from "./AddRunnitBoardMember.vue?vue&type=template&id=a7196c98"
import script from "./AddRunnitBoardMember.vue?vue&type=script&lang=ts"
export * from "./AddRunnitBoardMember.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports